import { Form, Modal } from "antd";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef } from "react";
import { addTranslations } from "../../../utils/functions/javaScriptHelper";
import ProjectFormItems from "./projectFormItems";
import { createInternshipJob } from "../../../actions/internshipJobPostingActions";

function usePrevious(value) {
	const ref = useRef();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
}

const CreateProjectModal = ({
	modalCloseHandler,
	isActionProgress,
	createInternshipJob,
	newProjectIndex,
}) => {
	const [form] = Form.useForm();
	const { t } = useTranslation();
	const prevActionInProgressValue = usePrevious(isActionProgress);

	useEffect(() => {
		if (!isActionProgress && prevActionInProgressValue) {
			modalCloseHandler();
		}
	}, [isActionProgress]);

	const createProject = async (formValues) => {
		let newAttachmentFile = null;
		if (formValues.attachment?.length) {
			newAttachmentFile = formValues.attachment[0].originFileObj;
		}
		let projectToCreate = {
			...(await addTranslations(formValues, [
				"title",
				"details",
				"otherComment",
			])),
			attachment: newAttachmentFile,
		};

		projectToCreate = Object.fromEntries(
			Object.entries(projectToCreate).filter(
				([_, value]) => value !== undefined
			)
		);

		createInternshipJob(projectToCreate);
	};

	return (
		<Modal
			title={
				<div className="project_card_title_banner">
					<div>{t("createProject_modalHeader")}</div>
					<div className="project_card_title_banner_projectNumber">{`${t(
						"project"
					)} #${newProjectIndex}`}</div>
				</div>
			}
			visible={true}
			onCancel={modalCloseHandler}
			footer={null}
			width={904}
		>
			<Form layout="vertical" form={form} onFinish={createProject}>
				<ProjectFormItems
					isActionProgress={isActionProgress}
					action={"create"}
					cancelActionHandler={modalCloseHandler}
				/>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	isActionProgress: state.internshipJobs.actionInProgress,
});

export default connect(mapStateToProps, { createInternshipJob })(
	CreateProjectModal
);
